export const CANONICAL_WEAR_OCCASIONS = Object.freeze([
  'Gym',
  'Work',
  'Casual',
  'Errands',
  'Date',
  'Night out',
  'Wedding',
  'Sporting event',
  'Concert',
  'Travel',
  'Vacation',
  'Formal event',
])

export const GYM_WEAR_OCCASION = 'Gym'

const CANONICAL_BY_NORMALIZED_VALUE = new Map([
  ['gym', GYM_WEAR_OCCASION],
  ['office', 'Work'],
  ['work', 'Work'],
  ['casual', 'Casual'],
  ['errands', 'Errands'],
  ['date', 'Date'],
  ['evening', 'Night out'],
  ['night out', 'Night out'],
  ['wedding', 'Wedding'],
  ['sporting event', 'Sporting event'],
  ['concert', 'Concert'],
  ['travel', 'Travel'],
  ['vacation', 'Vacation'],
  ['event', 'Formal event'],
  ['formal event', 'Formal event'],
])

export function canonicalizeWearOccasion(value) {
  if (value == null || String(value).trim() === '') return null
  const canonical = CANONICAL_BY_NORMALIZED_VALUE.get(String(value).trim().toLowerCase())
  if (!canonical) {
    throw new Error(`Choose a valid occasion: ${CANONICAL_WEAR_OCCASIONS.join(', ')}.`)
  }
  return canonical
}

export function isGymWear(log) {
  return String(log?.occasion || '').trim().toLowerCase() === GYM_WEAR_OCCASION.toLowerCase()
}

export function wearOccasionSaveAction(value, { skipOccasion = false } = {}) {
  const occasion = canonicalizeWearOccasion(value)
  return {
    action: occasion == null && !skipOccasion ? 'prompt' : 'save',
    occasion,
  }
}
